import React from 'react';
import prodPathReplace from 'shared/prod-path-rewrite';
import t from 'react-translate';

import { css } from '@emotion/react';
import { primary } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

import NvIcon from 'shared/components/nv-icon';

const MENTOR_PLUS_DIAMOND_SIZE = 25;
const DEFAULT_HEADER_BACKGROUND = prodPathReplace('images/mentoring-program-header-background-base-layer.png');
const DEFAULT_WIDTH = 95;
const DEFAULT_HEIGHT = 60;

type StylesProps = {
  coverImg: string;
  width: number;
  height: number;
};

const styles = ({ coverImg, width, height }: StylesProps) => css`
  align-items: center;
  justify-content: center;

  background: url("${coverImg}") ${primary} center center / cover no-repeat;
  border-radius: ${quarterSpacing}px;
  width: ${width}px;
  height: ${height}px;

  .mentor-plus-diamond {
    height: ${MENTOR_PLUS_DIAMOND_SIZE}px;
    width: ${MENTOR_PLUS_DIAMOND_SIZE}px;
    background-color: ${primary};
    transform: rotate(45deg);
    i {
      transform: rotate(-45deg);
    }
    border-top-left-radius: ${quarterSpacing}px;
    border-bottom-right-radius: ${quarterSpacing}px;
    box-shadow: 0px 1px 11px rgba(0, 0, 0, 0.1), 0px 3px 2px rgba(0, 0, 0, 0.1);
  }
`;

type NvProgramThumbnailProps = {
  headerBackground?: string;
  className?: string;
  width?: number;
  height?: number;
};

const NvProgramThumbnail = ({
  headerBackground,
  className = '',
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
}: NvProgramThumbnailProps) => (
  <div
    css={styles({ coverImg: headerBackground || DEFAULT_HEADER_BACKGROUND, width, height })}
    className={`cover-image d-flex ${className}`}
    data-cover-img={headerBackground || DEFAULT_HEADER_BACKGROUND}
  >
    <div
      className='mentor-plus-diamond d-flex align-items-center justify-content-center'
      role='img'
      aria-label={t.MENTORING_PROGRAMS.PROGRAM_THUMBNAIL.ALT_TEXT()}
    >
      <NvIcon
        icon='mentor-plus'
        size='smallest'
        className='text-white'
      />
    </div>
  </div>
);

export default NvProgramThumbnail;
